import { DRL_COMPOUNDING_ALIAS, DRL_COMPOUNDING_PERIODS_ALIAS } from 'common/constants/cap-table';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { AfterCellChangedHandler, DividendRateLedgerChange } from './types';

const handleCompoundingChange: AfterCellChangedHandler = (currentChange, cells, changes) => {
  const { cell, value: compoundingValue } = currentChange;
  const { key: currentChangeKey } = cell;

  const sameRowCompoundingCells = Object.values(cells).filter(
    ({ alias, isTitleCell, key }) => alias === DRL_COMPOUNDING_ALIAS && !isTitleCell && key !== currentChangeKey
  );
  const compoundingPeriodsCells = Object.values(cells).filter(
    ({ alias, isTitleCell }) => alias === DRL_COMPOUNDING_PERIODS_ALIAS && !isTitleCell
  );
  const compoundingPeriodsValue = Number(compoundingValue) === 1 ? 1 : null;
  changes.push(...sameRowCompoundingCells.map(rowCell => ({ cell: rowCell, value: compoundingValue })));
  changes.push(...compoundingPeriodsCells.map(rowCell => ({ cell: rowCell, value: compoundingPeriodsValue })));
};

const handleCompoundingPeriodsChange: AfterCellChangedHandler = (currentChange, cells, changes) => {
  const { cell, value: compoundingPeriodsValue } = currentChange;
  const { key: currentChangeKey } = cell;

  const sameRowCompoundingPeriodsCells = Object.values(cells).filter(
    ({ alias, isTitleCell, key }) => alias === DRL_COMPOUNDING_PERIODS_ALIAS && !isTitleCell && key !== currentChangeKey
  );
  changes.push(...sameRowCompoundingPeriodsCells.map(rowCell => ({ cell: rowCell, value: compoundingPeriodsValue })));
};

const afterCellChanged = (changes: DividendRateLedgerChange[], cells: { [key: string]: ICell }) => {
  const changeList = [] as DividendRateLedgerChange[];

  const handlersByAlias: { [key: string]: AfterCellChangedHandler } = {
    [DRL_COMPOUNDING_ALIAS]: handleCompoundingChange,
    [DRL_COMPOUNDING_PERIODS_ALIAS]: handleCompoundingPeriodsChange,
  };

  changes.forEach(change => {
    const { cell, value } = change;
    changeList.push({ cell, value });
    handlersByAlias[cell.alias as string]?.(change, cells, changeList);
  });
  return changeList;
};

export default afterCellChanged;
